// Copyright 2022 Sorama B.V.

// Handles device selection and communication with local storage
export abstract class CamIV64SelectionManager {
    private static _selectedDeviceId = "";

    // Checks if a device is currently selected
    public static get isDeviceSelected(): boolean {
        return this.selectedDeviceId !== "";
    }

    // Retrieves the selected device ID
    public static get selectedDeviceId(): string {
        // On first access, initialize from localStorage if not already set
        if (this._selectedDeviceId === "") {
            this._selectedDeviceId = this.preferredDevice;
        }
        return this._selectedDeviceId || "";
    }

    // Sets the selected device ID and updates the preferred device in local storage
    public static set selectedDeviceId(deviceId: string) {
        this._selectedDeviceId = deviceId;

        if (deviceId && deviceId !== "") {
            CamIV64SelectionManager.updatePreferredDevice(deviceId);
        } else {
            CamIV64SelectionManager.clearPreferredDevice();
        }
    }

    //#region Local Storage handling for preferred device

    private static readonly localStorageKey = "selectedCamIV64";

    // Retrieves the preferred device from local storage
    public static get preferredDevice(): string {
        return localStorage.getItem(CamIV64SelectionManager.localStorageKey) ?? "";
    }

    // Updates the preferred device in local storage
    private static updatePreferredDevice(deviceId: string): void {
        localStorage.setItem(CamIV64SelectionManager.localStorageKey, deviceId);
    }

    // Clears the preferred device in local storage
    private static clearPreferredDevice(): void {
        localStorage.removeItem(CamIV64SelectionManager.localStorageKey);
    }

    //#endregion
}
